import { inputTemplateIDs } from './inputTemplateIDs';
import { getDefaultSelectValue } from './inputsSetups';

const { accessoriesTemplateID, checkboxTemplateID, datepickerTemplateID, dropdownTemplateID, fieldUploadTemplateID, textFieldTemplateID, textareaTemplateID } = inputTemplateIDs;

export const clearAccessorySummary = ({ sectionID }) => clearSummaryRow({ id: `replace-receivers_${sectionID}` });

export const clearSummaryRow = ({ id }) => {
    const summaryItemRelatedToCurrentField = document.getElementById(id);
    summaryItemRelatedToCurrentField?.remove();
}

const createSummaryItem = ({ id, itemTitle, newValue, parentDiv, sectionID }) => {
    const currentWarrantyAction = sessionStorage.getItem('currentWarrantyAction');
    const newSummaryItem = document.createElement('div');
    const sectionName = `${itemTitle.toLowerCase().replaceAll(' ', '-')}_${sectionID}`;
    const summarySection = document.getElementById(sectionName) || document.createElement('div');
    const newTitleDiv = document.createElement('div');
    const newValueDiv = document.createElement('div');

    newSummaryItem.id = id;
    newSummaryItem.appendChild(newTitleDiv);
    newSummaryItem.appendChild(newValueDiv);
    newSummaryItem.classList.add('configurator_info', currentWarrantyAction);
    parentDiv.appendChild(summarySection);
    summarySection.appendChild(newSummaryItem);
    newTitleDiv.classList.add('configurator_info__title');
    newValueDiv.classList.add('configurator_info__value');
    newTitleDiv.innerHTML = itemTitle;
    newValueDiv.innerHTML = newValue;

    if (!summarySection.id) {
        summarySection.id = sectionName; 
        summarySection.classList.add('summarySection');
    }
}

const handleUpdateSummary = ({ id, inputTemplateID, itemTitle, newValue, summaryItemRelatedToCurrentField, parentDiv, sectionID }) => {
    if (summaryItemRelatedToCurrentField) {
        updateSummaryItem({ inputTemplateID, newValue, summaryItemRelatedToCurrentField });
    } else {
        createSummaryItem({ id, itemTitle, newValue, parentDiv, sectionID });
    }
}

const getWarrantySummaryAccessoriesDiv = ({ mainDiv }) => {
    const accessoriesSummary = mainDiv.querySelector('.configurator_info-accessories');

    if (accessoriesSummary) return accessoriesSummary;
    else {
        const newAccessoriesSummary = document.createElement('div');
        newAccessoriesSummary.classList.add('configurator_info-accessories');
        mainDiv.appendChild(newAccessoriesSummary);
        
        return newAccessoriesSummary;
    }
}

const getProductDiv = ({ isAccessory, mainDiv, sectionID }) => {
    const warrantySummaryMainProductDiv = mainDiv.querySelector('.configurator_info.configurator_info-related-product.configurator_info-main-product');
    const warrantySummaryRelProductDiv = mainDiv.querySelector(`.serial-${sectionID}`);
    const isRelatedProduct = Boolean(warrantySummaryRelProductDiv);

    if (isAccessory) return getWarrantySummaryAccessoriesDiv({ mainDiv });
    else if (isRelatedProduct) return warrantySummaryRelProductDiv;
    else return warrantySummaryMainProductDiv;
}

const updateSummaryItem = ({ inputTemplateID, newValue, summaryItemRelatedToCurrentField }) => {
    const isAccessory = inputTemplateID === accessoriesTemplateID;
    const isDatepicker = inputTemplateID === datepickerTemplateID;
    const isDropDown = inputTemplateID === dropdownTemplateID;
    const isTextField = inputTemplateID === textFieldTemplateID;
    const isTextArea = inputTemplateID === textareaTemplateID;

    if (newValue && (isAccessory || isDatepicker || isDropDown || isTextArea || isTextField)) {
        summaryItemRelatedToCurrentField.querySelector('.configurator_info__value').innerHTML = newValue;
    } else {
        summaryItemRelatedToCurrentField.remove();
    }
}

//sectionID is needed for cases when we have multiple related products and choose that sameReasons flag is set as false
export const updateSummaryOnInputChange = ({ field, input, sectionID }) => {
    let timeout = null;
    // e.g. "warranty"
    const view = document.querySelector('.configurator_controllers').id.replace('-form-panel', '');
    const inputTemplateID = field.TemplateId;
    const isAccessory = inputTemplateID === accessoriesTemplateID;
    const isDatepicker = inputTemplateID === datepickerTemplateID;
    const isDropDown = inputTemplateID === dropdownTemplateID;
    const isCheckbox = inputTemplateID === checkboxTemplateID;
    const isFieldUpload = inputTemplateID === fieldUploadTemplateID;
    const eventType = isDatepicker || isDropDown || isFieldUpload ? "change" : "input";
    const mainDiv = document.getElementById(`${view}-summary-specifics`).querySelector(`.${view}Summary`);
    const timeoutValue = isCheckbox ? 0 : 700; //0 is set to avoid wrong data while fast clicking a checkbox
    const currentWarrantyAction = sessionStorage.getItem('currentWarrantyAction');
    const canSummaryBeUpdated = currentWarrantyAction !== 'repair' && currentWarrantyAction !== 'remake' && currentWarrantyAction !== 'LostAndDamage'; //in case of simple inputs (so other than multiselector) updating summary should not be implemented for Repair and Remake actions, just for views do not containing Multiselector. Regarding 374555 task L&D should be excluded too

    const updateSummary = (e) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            const normalizedSitecoreInputID = field.NormalizedId;
            const id = `id-${normalizedSitecoreInputID}-${sectionID}`;
            const actionChangedBeforeTimeoutExecuted = currentWarrantyAction !== sessionStorage.getItem('currentWarrantyAction');

            const setNewValue = (e) => {
                const yesLabel = document.getElementById('summary-warranty').getAttribute('data-yeslabel');
                if (isFieldUpload) return e.target.files?.[0]?.name;
                else if (isDropDown) return e.target.selectedOptions?.[0]?.innerText;
                else if (isCheckbox) return yesLabel;
                else if (isAccessory) return e.target.innerText;
                else return e.target.value;
            }

            const setTitle = () => {
                if(isFieldUpload) return field.Name;
                else if (isCheckbox) return field.DisplayName;
                else if (isAccessory) {
                    const value = document.getElementById('warranty-replacereceiver').querySelector('h4').innerText;
                    return value;
                }
                else return field.DisplayName;
            }

            const newValue = setNewValue(e);
            const summaryItemRelatedToCurrentField = mainDiv.querySelector(`#${id}`);
            const itemTitle = setTitle();
            const parentDiv = getProductDiv({ isAccessory, mainDiv, sectionID });
            const defaultSelectValue = getDefaultSelectValue();
            const isDefaultSelectValue = newValue === defaultSelectValue;

            if(!actionChangedBeforeTimeoutExecuted && !isDefaultSelectValue) {
                handleUpdateSummary({ id, inputTemplateID, itemTitle, newValue, summaryItemRelatedToCurrentField, parentDiv, sectionID });
            } else if (isDefaultSelectValue) {
                if (isAccessory) clearAccessorySummary({ sectionID });
                else if (isDropDown) clearSummaryRow({ id: `drop-down-field_${sectionID}` }); 
            }
        }, timeoutValue);
    }

    if(canSummaryBeUpdated) {
        if (isAccessory) {
            const liDivs = input.querySelectorAll('li');
            liDivs?.forEach((liDiv) => liDiv.addEventListener("click", (e) => updateSummary(e)));
        } else {
            input.addEventListener(eventType, (e) => updateSummary(e));
        }
    }
}